'use strict';

const analyticsHelper = require('../util/analyticsHelper');

/**
 * This function animates wishlist header icon.
 */
function animateWishlistHeaderIcon () {
    const $heartIcon = $('.wishlist-icon.icon-header');
    const defaultIcon = $heartIcon.data('default-icon');
    const filledIcon = $heartIcon.data('filled-icon');

    $heartIcon.attr('src', filledIcon);

    setTimeout(function() {
        $heartIcon.addClass('item-added-animation');
    }, 150);

    setTimeout(function() {
        $heartIcon.removeClass('item-added-animation');
        $heartIcon.attr('src', defaultIcon);
    }, 800);
}

/**
 * appends params to a url and changes the wishlist icon
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} $wishlistTile - jQuery object of the clicked wishlist tile
 * @param {boolean} showNotification - indicates if shows notification feedback message
 */
function displayMessageAndChangeIcon(data, $wishlistTile, showNotification) {
    var status;
    var $icon = $wishlistTile.find('i');

    if (data.success) {
        status = 'alert-success';
        if ($icon.hasClass('fa-heart-o')) {
            $icon.removeClass('fa-heart-o').addClass('fa-heart');
            $wishlistTile.data('is-in-wishlist', true);
            if (showNotification) {
                animateWishlistHeaderIcon();
                $(document).trigger('showNotificationClient', {
                    type: 'success',
                    message: data.msg,
                    cssClass: 'wishlist-pdp-notification-message'
                });
            }
        } else {
            $icon.removeClass('fa-heart').addClass('fa-heart-o');
            $wishlistTile.data('is-in-wishlist', false);
        }
    } else {
        status = 'alert-danger';
    }
}

module.exports = {
    toggleWishlist: function () {
        $('body').on('click', '.wishlist-toggle', function (e) {
            e.preventDefault();
            var $wishlistTile = $(this);
            var isInWishlist = $wishlistTile.data('is-in-wishlist') === true;
            var url = isInWishlist ? $wishlistTile.data('remove-url') : $wishlistTile.data('add-url');
            var pid = $wishlistTile.data('pid');
            var optionId = $wishlistTile.closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $wishlistTile.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            var showNotification = $wishlistTile.parent().hasClass('show-notification');
            optionId = optionId || null;
            optionVal = optionVal || null;

            if (!url || !pid) {
                return;
            }

            $.ajax({
                url: url,
                type: isInWishlist ? 'get' : 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessageAndChangeIcon(data, $wishlistTile, showNotification);
                    if (!isInWishlist) {
                        analyticsHelper.trackEvent('wishlist', {
                            items: [{
                                item_id: pid
                            }]
                        });
                    }
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, $wishlistTile, showNotification);
                }
            });
        });
    }
};
